import React, { useState, useEffect, useRef, useCallback, useReducer, useMemo } from "react";
import styled from "styled-components";

import copy from "copy-to-clipboard";

import copy_img from "../../../assets/images/copy_img.png";
import toast from "react-hot-toast";
import UserInvitedFriendsTool from "./UserInvitedFriendsTool";

const HOST = "https://студтуризм.рф";

export default function UserReferralsTool(props) {
    const {
        user,
        adminMode = false
    } = props;

    if (user == undefined) {
        return (
            <div>
                ...
            </div>
        );
    }

    let refUrl = `${HOST}/invite/${user.id}`;

    return (
        <Wrapper>

            <TopPlaceholder>
                <div>
                    {adminMode == true ? null :
                        <div>
                            {`Ваша реферальная ссылка:`}
                        </div>
                    }
                    <br />
                    <RefPlaceholder>

                        <a href={refUrl} target={"_blank"}>
                            {refUrl}
                        </a>

                        <CopyImg src={copy_img} onClick={() => {
                            copy(refUrl);
                            toast.success("Ссылка скопирована в буфер обмена");
                        }} />

                    </RefPlaceholder>
                </div>
            </TopPlaceholder>

            {/*<pre dangerouslySetInnerHTML={{__html: JSON.stringify(user, null, 2)}} >*/}

            {/*</pre>*/}

            <InvitedFriendsPlaceholder>
                <UserInvitedFriendsTool
                    userId={user?.id}
                />
            </InvitedFriendsPlaceholder>

        </Wrapper>
    );
}

const InvitedFriendsPlaceholder = styled.div`

`;

const Wrapper = styled.div`
  font-family: "Noto Sans", sans-serif;
`;

const CopyImg = styled.img`
  height: 20px;
  width: 20px;
  cursor: pointer;
  opacity: 0.7;
  margin-left: 5px;
  display: inline-block;

  :hover {
    opacity: 1;
  }
`;

const TopPlaceholder = styled.div`
  margin-bottom: 10px;
  font-family: "Noto Sans", sans-serif;
`;

const RefPlaceholder = styled.div`
  padding: 10px;
  border: 1px dashed #ccc;
  background: white;
  border-radius: 40px;
  padding-left: 20px;
  padding-right: 20px;
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  align-items: center;
`;